import { render, staticRenderFns } from "./ResourceTags.vue?vue&type=template&id=572aa665&scoped=true"
import script from "./ResourceTags.vue?vue&type=script&lang=js"
export * from "./ResourceTags.vue?vue&type=script&lang=js"
import style0 from "./ResourceTags.vue?vue&type=style&index=0&id=572aa665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572aa665",
  null
  
)

export default component.exports